export default {
    SalesReport: 'sales',
    RefundedGiftReport: 'refundedGift',
    PromoCodeUsageReport: 'PromoCodeUsage',
    RedemptionCodeUsageReport: 'RedemptionCodeUsageReport',
    ContactUsSubmissionsReport: 'ContactUsSubmissionsReport',
    EnrolledGiftsReport: 'EnrolledGiftReport',
    CrossTerritorySalesReport: 'CrossTerritorySalesReport'
}